import { useEffect } from 'react';

import gsap from 'gsap/dist/gsap';
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import { useWindowSize } from 'common/hook/useWindowSize';
import { Button } from 'common/components/Button';

gsap.registerPlugin(DrawSVGPlugin, ScrollToPlugin, ScrollTrigger);

export const Services: React.FC = () => {
  const { t } = useTranslation('pageServices');
  const { dimensions } = useWindowSize();

  useEffect(() => {
    if (dimensions.window.width > 600) {
      const dataOne = {
        opacity: 0,
        duration: 2,
        scrollTrigger: {
          trigger: '#service-item-panel-2',
          start: 'top 80%',
          end: 'top 20%',
          scrub: true,
        },
      };
      gsap.to('#service-item-panel-1 article', {
        ...dataOne,
        scrollTrigger: { ...dataOne.scrollTrigger, trigger: '#service-item-panel-2' },
      });
      gsap.to('#service-item-panel-2 article', {
        ...dataOne,
        scrollTrigger: { ...dataOne.scrollTrigger, trigger: '#service-item-panel-3' },
      });
      gsap.to('#service-item-panel-3 article', {
        ...dataOne,
        scrollTrigger: { ...dataOne.scrollTrigger, trigger: '#service-item-panel-4' },
      });
      gsap.to('#service-item-panel-4 article', {
        ...dataOne,
        scrollTrigger: { ...dataOne.scrollTrigger, trigger: '#service-item-panel-5' },
      });
      gsap.to('#service-item-panel-5 article', {
        ...dataOne,
        scrollTrigger: { ...dataOne.scrollTrigger, trigger: '#service-item-panel-6' },
      });
    }
  }, [dimensions.window.width]);

  const renderSections = () => {
    const services: any = t('services', { returnObjects: true });
    if (!services?.length) {
      return <></>;
    }
    return services?.map(({ content, image, title }: any, index: number) => (
      <article
        id={`strategy-item-panel-${index + 1}`}
        key={title}
        className="bg-gradient lg:sticky lg:top-0">
        <div className="grid h-full flex-row items-center justify-center px-5 py-10 lg:grid-cols-2">
          <div className="flex items-center justify-center lg:min-h-[85vh]">
            <Image
              className="mx-auto mb-4 h-auto w-full max-w-[800px] rounded-xl object-contain lg:mb-10 lg:w-3/5"
              src={image?.src}
              alt={title}
              width={500}
              height={500}
            />
          </div>
          <div>
            <div className="mb-1 mr-2 w-6 border-b-4 border-b-primary pb-1 font-black">
              0{index + 1}
            </div>
            <h2
              className="text-heading-work-item mb-8 max-w-xl font-bold"
              dangerouslySetInnerHTML={{ __html: title }}
            />

            <p className="mb-8 max-w-2xl " dangerouslySetInnerHTML={{ __html: content }} />

            {index + 1 === services.length && (
              <div className="w-[300px]">
                <Button className="mt-6 w-full" href={t('common:contactProjectSlug')}>
                  {t('common:workWithUs')}
                </Button>
              </div>
            )}
          </div>
        </div>
      </article>
    ));
  };

  return (
    <section id="strategy-panel" className="relative">
      <div className="relative">{renderSections()}</div>
    </section>
  );
};
